export const ImageStyles = {
  modalProgramImage: {
    height: '80px',
    width: '80px',
    borderRadius: '4px',
  },
};
